import { Attribution } from 'types'

interface Params {
  endDate: string
  startDate: string
  id: string
  attr: Attribution
}

export const getOrganicChannelSum = ({
  endDate,
  startDate,
  attr,
  id,
}: Params) => {
  switch (attr) {
    case 'first':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(first.new_customers), SUM(first.leads), SUM(first.total_orders), SUM(first.total_amount), SUM(first.recurring_payments_amount), SUM(first.orders_amount) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.channel_id = '${id}'`
    case 'last':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(last.new_customers), SUM(last.leads), SUM(last.total_orders), SUM(last.total_amount), SUM(last.recurring_payments_amount), SUM(last.orders_amount) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.channel_id = '${id}'`
    case 'linear':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(stats.new_customers), SUM(linear_source.leads), SUM(linear_source.total_orders), SUM(linear_source.total_amount), SUM(linear_source.recurring_payments_amount), SUM(linear_source.orders_amount) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.channel_id = '${id}'`
    case 'ai':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(stats.new_customers), SUM(ai_source.leads), SUM(ai_source.total_orders), SUM(ai_source.total_amount), SUM(ai_source.recurring_payments_amount), SUM(ai_source.orders_amount) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.channel_id = '${id}'`
    default:
      return ''
  }
}
